const locale = state => state.locale;

export default {
    locale,
};
